export type LessonStartIntent = 'individual' | 'group';

export const LESSON_START_INTENT_STATE_KEY = 'lessonStartIntent';

export function lessonStartIntentFrom(
  state: Record<string, unknown> | undefined,
): LessonStartIntent | null {
  const value = state?.[LESSON_START_INTENT_STATE_KEY];
  return value === 'individual' || value === 'group' ? value : null;
}
